/**
 * interact.js 1.10.26
 *
 * Copyright (c) 2012-present Taye Adeyemi <dev@taye.me>
 * Released under the MIT License.
 * https://raw.github.com/taye/interact.js/main/LICENSE
 */

var isWindow = thing => !!(thing && thing.Window) && thing instanceof thing.Window;
export { isWindow as default };
//# sourceMappingURL=isWindow.js.map
